"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typographyWithGlobalCSS = exports.typography = exports.trackingToLetterSpacing = exports.default = void 0;
var _lodashEs = require("lodash-es");
var _styledComponents = require("styled-components");
const trackingToLetterSpacing = function (spacing) {
  return `${spacing / 1000}em`;
};
exports.trackingToLetterSpacing = trackingToLetterSpacing;
const getter = function (namespace) {
  return `
    font: var(--${namespace}-font);
    letter-spacing: var(--${namespace}-letter-spacing);
  `;
};
const typography = function (fontConfig) {
  if (typeof fontConfig === "string") {
    return getter(fontConfig);
  }
  const fonts = (0, _lodashEs.mapValues)(fontConfig, function (_ref) {
    let {
      defaults = {
        spacing: "initial"
      },
      aliases,
      sizings,
      family
    } = _ref;
    const setter = function () {
      let namespace = "",
        props,
        splitFontDefinitions = false;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      const isBoth = args.length > 1 && typeof args[1] !== "boolean";
      const isNamespace = !isBoth && !!(typeof args[0] === "string");
      const isProps = !isBoth && !!(typeof args[0] === "object");

      // Todo: clean up this... questionable logic
      if (isBoth) {
        var _args$;
        [namespace, props] = args;
        splitFontDefinitions = (_args$ = args[2]) !== null && _args$ !== void 0 ? _args$ : false;
      } else if (isProps) {
        var _args$2;
        props = args[0];
        splitFontDefinitions = (_args$2 = args[1]) !== null && _args$2 !== void 0 ? _args$2 : false;
      } else if (isNamespace) {
        var _args$3;
        // I'm not sure if this condition ever occurs
        namespace = args[0];
        splitFontDefinitions = (_args$3 = args[1]) !== null && _args$3 !== void 0 ? _args$3 : false;
      }
      if (namespace) {
        namespace = `--${namespace}-`;
      }
      const {
        sizing,
        ...opts
      } = {
        ...defaults,
        ...props
      };
      const getValue = function (k) {
        var _aliases$k$v, _aliases$k;
        const v = opts[k] || "";
        return (_aliases$k$v = aliases === null || aliases === void 0 ? void 0 : (_aliases$k = aliases[k]) === null || _aliases$k === void 0 ? void 0 : _aliases$k[v]) !== null && _aliases$k$v !== void 0 ? _aliases$k$v : v;
      };
      const style = getValue("style");
      const weight = getValue("weight");
      const sizingVal = sizings[sizing];
      const [size, height] = (sizingVal === null || sizingVal === void 0 ? void 0 : sizingVal.split("/")) || [];
      const spacing = getValue("spacing");
      return `
        ${!splitFontDefinitions ? `
          ${namespace}font: ${style} ${weight} ${sizingVal} ${family};
          ${namespace}letter-spacing: ${spacing};
					@media print {
						${`font-family: ${family}, Helvetica, Arial, sans-serif;`}
					}
          ` : `
          ${family && `font-family: ${family};`}
          ${size && `font-size: ${size};`}
          ${height && `line-height: ${height};`}
          ${style && `font-style: ${style};`}
          ${weight && `font-weight: ${weight};`}
          ${spacing && `letter-spacing: ${spacing};`}
					@media print {
						${`font-family: ${family}, Helvetica, Arial, sans-serif;`}
					}
        `}
      `;
    };

    // Append the config so you don't have to search for it
    setter.config = {
      defaults,
      aliases,
      sizings
    };
    return setter;
  });
  return fonts;
};
exports.typography = typography;
const typographyWithGlobalCSS = function (fontConfig) {
  const fonts = typography(fontConfig);
  const GlobalCSS = (0, _lodashEs.mapValues)(fontConfig, function (_ref2, font) {
    let {
      sizings,
      aliases
    } = _ref2;
    const sizingClasses = Object.keys(sizings).reduce(function (acc, key) {
      return acc + `
      .${font}-sizing-${key}{
        ${fonts[font]({
        sizing: key
      }, true)}
      }
    `;
    }, "");
    const aliasClasses = Object.keys(aliases).reduce(function (acc, prop) {
      return acc + Object.keys(aliases[prop]).reduce(function (acc2, key) {
        return acc2 + `
        .${font}-${prop}-${key} {
          ${fonts[font]({
          [prop]: key
        }, true)}
        }
      `;
      }, "");
    }, "");
    const fullClassString = `${sizingClasses} ${aliasClasses}`.replace(/\s\s+/g, " ").trim();
    return _styledComponents.createGlobalStyle[fullClassString];
  });
  return {
    ...fonts,
    GlobalCSS
  };
};
exports.typographyWithGlobalCSS = typographyWithGlobalCSS;
var _default = exports.default = typography;